import { useMediaQuery } from "../../hooks/useMediaQuery";
import {
  DialogBody,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  MOBILE_QUERY,
} from "../Dialog";
import type { IDrawerProps } from "./types";

const DrawerRoot = ({ side = "right", ...props }: IDrawerProps) => {
  const isMobile = useMediaQuery(MOBILE_QUERY);

  return <DialogRoot {...props} placement={isMobile ? "bottom" : side} />;
};

export const Drawer = Object.assign(DrawerRoot, {
  Header: DialogHeader,
  Body: DialogBody,
  Footer: DialogFooter,
});
